import { PaisEnum } from '@app/core/models';
import { RoleFn } from './role';

const role: RoleFn = ({ usuario_ativo }) =>
  usuario_ativo?.pais_id !== PaisEnum.Brasil || !usuario_ativo?.aluno_id || usuario_ativo?.pcd;

export default role;
